import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Card,
  CardMedia,
  CardActions,
  IconButton,
  Box,
  Button,
  DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { Api_Token } from "../../env";
import { BackLoadingSimple } from "../loading/backLoading";
import { useAlertContext } from "../../service/AlertServices";

function PopupGestionBackground({ open, onClose, eventId }) {
  const [backgrounds, setBackgrounds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { showAlert } = useAlertContext();

  useEffect(() => {
    if (open && eventId) {
      fetchBackgrounds();
    }
  }, [open, eventId]);

  const fetchBackgrounds = async () => {
    setLoading(true);
    try {
      const res = await Api_Token.get(
        `backgroundEvent/GetBackGroundByEventId/${eventId}`
      );
      setBackgrounds(res.data || []);
    } catch (e) {
      // Optionally show an alert
    }
    setLoading(false);
  };

  const handleDelete = async (bgId) => {
    try {
      await Api_Token.delete(`backgroundEvent/DeleteBackgroundEvent/${bgId}`);
      setBackgrounds((prev) => prev.filter((bg) => bg.id !== bgId));
    } catch {
      // Optionally show an alert
    }
  };

  const handleAddBackground = async (e) => {
    if (selectedFiles.length === 0) {
      showAlert("Veuillez sélectionner une image", "warning");
      return;
    }

    const form = new FormData();
    selectedFiles.forEach((file) => {
      form.append("backgroundImage", file);
    });
    form.append("idEvent", eventId);

    try {
      await Api_Token.post("backgroundEvent/AddNewBackgroundEvent", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      showAlert("Image(s) ajoutée(s)", "success");
      fetchBackgrounds();
      setSelectedFiles([]);
    } catch (err) {
      console.error(err);
      showAlert("Erreur lors de l'ajout", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Gestion arrière-plan</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {backgrounds.map((bg) => (
            <Grid item xs={6} sm={4} key={bg.id}>
              <Card>
                <CardMedia
                  component="img"
                  height="120"
                  image={bg.Url}
                  alt="background"
                  sx={{ objectFit: "cover" }}
                />
                <CardActions>
                  <IconButton color="error" onClick={() => handleDelete(bg.id)}>
                    <DeleteIcon />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
        <DialogActions>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={6}>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                type="submit"
                onClick={handleAddBackground}
              >
                add
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={onClose}
                fullWidth
              >
                Fermer
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </DialogContent>
      <BackLoadingSimple open={loading} />
    </Dialog>
  );
}

export default PopupGestionBackground;
